import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const container = css`
  display: grid;
  grid-template-columns: fit-content(160px) 1fr;
  column-gap: var(${spacing.sm});
`;

export const attributeItem = css`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  padding: var(${spacing.md}) 0;
  border-bottom: 1px solid var(${colors.stroke.default});

  b {
    font-weight: 700;
  }
`;
